import React from 'react';

export const RuFirstMotionModal = {
  title: 'First Motion',
  body: (
    <div>
      The first motion of the wave whether rise or fall.
      <ul>
        <li>R = Rise</li>
        <li>F = Fall</li>
      </ul>
    </div>
  ),
};
